/**
 * rendi-wizard-footer — persistent estimate + proceed bar.
 *
 * Wraps the server-rendered estimate label/value and the Prosegui button so the
 * host form drives the displayed value and the button state without reaching
 * into the markup. Emits `rendi:proceed` when the button is pressed.
 *
 * The footer has four layouts, driven by setMode:
 *   - question: estimate + proceed (the default wizard bar)
 *   - trust: estimate + proceed, shipping badge on its own row
 *   - details: estimate + confirm button
 *   - confirmation: estimate + the external CTA link
 */
if (!customElements.get('rendi-wizard-footer')) {
  class RendiWizardFooter extends HTMLElement {
    connectedCallback() {
      this.estimateBlock = this.querySelector('[data-footer-estimate]');
      this.labelNode = this.querySelector('[data-footer-label]');
      this.valueNode = this.querySelector('[data-footer-value]');
      this.button = this.querySelector('[data-wizard-next]');
      this.buttonLabel = this.querySelector('[data-wizard-next-label]');
      this.badge = this.querySelector('[data-footer-badge]');
      this.cta = this.querySelector('[data-footer-cta]');

      this.handleClickBound = this.handleClick.bind(this);
      this.button?.addEventListener('click', this.handleClickBound);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClickBound);
    }

    handleClick() {
      this.dispatchEvent(new CustomEvent('rendi:proceed', { bubbles: true }));
    }

    setEstimate(text) {
      if (this.valueNode) {
        this.valueNode.textContent = text;
      }
    }

    setLabel(text) {
      if (this.labelNode && text) {
        this.labelNode.textContent = text;
      }
    }

    setProceed({ visible, enabled, label }) {
      if (!this.button) return;
      this.button.hidden = !visible;
      this.button.disabled = !enabled;
      if (label && this.buttonLabel) {
        this.buttonLabel.textContent = label;
      }
    }

    setMode(mode) {
      this.dataset.mode = mode;
      const isConfirmation = mode === 'confirmation';
      if (this.badge) this.badge.hidden = mode !== 'trust';
      if (this.cta) this.cta.hidden = !isConfirmation;
      if (isConfirmation && this.button) this.button.hidden = true;
    }
  }

  customElements.define('rendi-wizard-footer', RendiWizardFooter);
}
